module.exports = __webpack_public_path__ + "img/collection-weddingRingsCarbon.678827d.jpg";